import builder from '../builder';
import SingleNeutralIDCard4 from '../../streamline-icons/bold/single-neutral-id-card-4.svg';

export default builder('IconSingleNeutralIDCard4Bold', SingleNeutralIDCard4);
